// menu-submenu.js

const Menu = {
  config: {
    submenuToggleSelector: "[data-submenu-toggle]",
    submenuWrapperSelector: ".dropdown-submenu",
    submenuMenuSelector: ".dropdown-menu",
    dropdownSelector: ".main-menu .dropdown",
    expandedSelector: "[data-submenu-toggle][aria-expanded='true']",
  },

  handleToggleClick: function (event) {
    const toggle = event.target.closest(Menu.config.submenuToggleSelector);
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation(); // evita que Bootstrap cierre el dropdown padre

    const parentLi = toggle.closest(Menu.config.submenuWrapperSelector);
    if (!parentLi) return;

    const submenu = parentLi.querySelector(Menu.config.submenuMenuSelector);
    if (!submenu) return;

    const isOpen = submenu.classList.contains("show");

    const siblings = parentLi.parentElement
      ? parentLi.parentElement.querySelectorAll(
          `${Menu.config.submenuWrapperSelector} ${Menu.config.submenuMenuSelector}.show`
        )
      : [];

    siblings.forEach((sib) => {
      if (sib !== submenu) sib.classList.remove("show");
    });

    submenu.classList.toggle("show", !isOpen);
    toggle.setAttribute("aria-expanded", !isOpen ? "true" : "false");
  },

  closeSubmenus: function (dropdownEl) {
    dropdownEl
      .querySelectorAll(`${Menu.config.submenuMenuSelector}.show`)
      .forEach((submenu) => submenu.classList.remove("show"));

    dropdownEl
      .querySelectorAll(Menu.config.expandedSelector)
      .forEach((btn) => btn.setAttribute("aria-expanded", "false"));
  },

  init: function () {
    document.addEventListener("click", Menu.handleToggleClick);

    const dropdowns = document.querySelectorAll(Menu.config.dropdownSelector);
    dropdowns.forEach((dropdownEl) => {
      dropdownEl.addEventListener("hide.bs.dropdown", () => {
        Menu.closeSubmenus(dropdownEl);
      });
    });
  },
};

document.addEventListener("DOMContentLoaded", function () {
  Menu.init();
});
